import React from "react";
import { LimitsApplyAccordion } from "../../../components";
import { Plan } from "../../../@types";
import {
  getBenefitCost,
  getBenefitExclusionsAndLimitations,
} from "../../../helpers";

/**
 * BenefitData represents a benefit in plan_card.package_benefits
 */
export interface BenefitData {
  label: string;
  service: string;
}

/**
 * convert array of BenefitData[] into table-friendly data that
 * can be rendered by `<RenderedTable>`
 * @param plan the plan
 * @param suppressed indicates to suppress the benefit or not
 * @param t translation function
 * @param category the benefit category
 * @param benefits array of BenefitData[]
 * @returns Record<string, unknown>[]
 */
export const convertBenefitData = (
  plan: Plan,
  suppressed: boolean,
  t: (id: string) => string,
  category: string,
  benefits: BenefitData[],
  sectionLabel?: string
): Record<string, unknown>[] => {
  return benefits.map((benefit: BenefitData) => {
    return {
      label: benefit.label,
      value: suppressed
        ? t("suppressed_plan_benefit")
        : getBenefitCost(t, {
            plan,
            benefit: category,
            service: benefit.service,
          }),
      limitsApply: (
        <LimitsApplyAccordion
          descriptors={getBenefitExclusionsAndLimitations({
            plan,
            benefit: category,
            service: benefit.service,
          })}
          tealiumSectionName={`${sectionLabel}|${benefit.label}`}
          ga4SectionName={benefit.label}
        />
      ),
    };
  });
};
